module.exports = __webpack_public_path__ + "static/img/preview-05.a39d162a.webp";